// import React from "react";
// import { FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";

// function Footer() {
//   return (
//     <footer
//       className="text-light border-top w-100"
//       style={{
//         backgroundColor: "#002b80",
//         overflowX: "hidden", //  prevent micro overflow
//       }}
//     >
//       {/* FULL WIDTH STRIP */}
//       <div className="container-fluid px-3 px-md-5 py-4">
//         <div className="row g-4">
//           {/* Company Info */}
//           <div className="col-12 col-md-6">
//             <h5 className="fw-bold mb-3">Afrogebeya Technologies</h5>

//             <p className="mb-2 d-flex align-items-start">
//               <FaMapMarkerAlt className="me-2 mt-1" />
//               <span>
//                 Addis Ababa, Nifas Silk Lafto <br className="d-md-none" />
//                 Wereda 7
//               </span>
//             </p>

//             <p className="mb-2 d-flex align-items-center">
//               <FaEnvelope className="me-2" />
//               <a
//                 href="mailto:info@afrogebeya.com"
//                 className="text-light text-decoration-none"
//               >
//                 info@afrogebeya.com
//               </a>
//             </p>

//             <p className="mb-0 d-flex align-items-center">
//               <FaPhone className="me-2" />
//               <a
//                 href="tel:+251909999988"
//                 className="text-light text-decoration-none"
//               >
//                 +251909999988
//               </a>
//             </p>
//           </div>

//           {/* Legal */}
//           <div className="col-12 col-md-6">
//             <h5 className="fw-bold mb-3">Legal</h5>
//             <ul className="list-unstyled mb-0">
//               <li className="mb-2">
//                 <a href="/terms" className="text-light text-decoration-none">
//                   Terms & Conditions
//                 </a>
//               </li>
//               <li className="mb-2">
//                 <a href="/terms" className="text-light text-decoration-none">
//                   Privacy Policy
//                 </a>
//               </li>
//               <li>
//                 <a href="/terms" className="text-light text-decoration-none">
//                   Cookie Policy
//                 </a>
//               </li>
//             </ul>
//           </div>
//         </div>
//         {/* Bottom */}
//         <div className="text-center small border-light pt-3 mt-4">
//           © 2017-{new Date().getFullYear()} Afrogebeya Technologies. All rights
//           reserved.{" "}
//         </div>{" "}
//       </div>
//     </footer>
//   );
// }

// export default Footer;

import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaFacebookF,
  FaTelegramPlane,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import ImageFile from "../images/afrogebeya.png";
import "../styles/footer.css";

/* ─────────────────────────────────────────
   Static data — update here as needed
───────────────────────────────────────── */
const SHOP_LINKS = [
  { label: "All Products", to: "/products" },
  { label: "New Arrivals", to: "/products?sort=new", badge: "New" },
  { label: "Best Sellers", to: "/products?sort=top" },
  { label: "Deals & Offers", to: "/products?sort=sale", badge: "Sale" },
  { label: "Categories", to: "/categories" },
];

const SELLER_LINKS = [
  { label: "Become a Seller", href: "https://seller.afrogebeya.com" },
  {
    label: "Seller Dashboard",
    href: "https://seller.afrogebeya.com/dashboard",
  },
  {
    label: "Seller Guidelines",
    href: "https://seller.afrogebeya.com/guidelines",
  },
  { label: "Seller FAQ", href: "https://seller.afrogebeya.com/faq" },
];

const SUPPORT_LINKS = [
  { label: "Help Center", to: "/help" },
  { label: "Track Order", to: "/orders" },
  { label: "Return Policy", to: "/returns" },
  { label: "Contact Us", to: "/contact" },
];

const LEGAL_LINKS = [
  { label: "Terms & Conditions", to: "/terms" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Cookie Policy", to: "/cookies" },
];

const SOCIAL_LINKS = [
  {
    icon: <FaFacebookF />,
    href: "https://facebook.com/afrogebeya",
    label: "Facebook",
  },
  {
    icon: <FaTelegramPlane />,
    href: "https://t.me/afrogebeya",
    label: "Telegram",
  },
  {
    icon: <FaInstagram />,
    href: "https://instagram.com/afrogebeya",
    label: "Instagram",
  },
  {
    icon: <FaTwitter />,
    href: "https://twitter.com/afrogebeya",
    label: "Twitter",
  },
  {
    icon: <FaYoutube />,
    href: "https://youtube.com/@afrogebeya",
    label: "YouTube",
  },
  {
    icon: <FaLinkedinIn />,
    href: "https://linkedin.com/company/afrogebeya",
    label: "LinkedIn",
  },
];

const PAYMENT_METHODS = [
  "Telebirr",
  "CBE Birr",
  "Amole",
  "HelloCash",
  "Cash on Delivery",
];

/* ─────────────────────────────────────────
   Sub-components
───────────────────────────────────────── */
const FooterCol = ({ title, children }) => (
  <div className="ft-col">
    <h6 className="ft-col__title">{title}</h6>
    {children}
  </div>
);

/* ─────────────────────────────────────────
   Main component
───────────────────────────────────────── */
export default function Footer() {
  const [email, setEmail] = useState("");
  const [subDone, setSubDone] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    /* TODO: wire up newsletter API */
    setSubDone(true);
    setEmail("");
    setTimeout(() => setSubDone(false), 4000);
  };

  return (
    <footer className="ft-root" role="contentinfo">
      {/* ══════════════════════════════════
          Newsletter strip
      ══════════════════════════════════ */}
      <div className="ft-newsletter">
        <div className="ft-newsletter__inner">
          <div className="ft-newsletter__copy">
            <h4>Stay in the loop</h4>
            <p>
              Get exclusive deals, new arrivals and seller updates straight to
              your inbox.
            </p>
          </div>

          {subDone ? (
            <div className="ft-newsletter__success">
              ✓ You're subscribed — thanks!
            </div>
          ) : (
            <form className="ft-newsletter__form" onSubmit={handleSubscribe}>
              <input
                type="email"
                className="ft-newsletter__input"
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                aria-label="Email for newsletter"
              />
              <button type="submit" className="ft-newsletter__btn">
                Subscribe
              </button>
            </form>
          )}
        </div>
      </div>

      {/* ══════════════════════════════════
          Main grid
      ══════════════════════════════════ */}
      <div className="ft-main">
        {/* ── Brand column ── */}
        <div className="ft-col">
          <Link to="/" className="ft-brand__logo" aria-label="Afrogebeya home">
            <img src={ImageFile} alt="" className="ft-brand__logo-img" />
            <span className="ft-brand__name">
              Afro<span>gebeya</span>
            </span>
          </Link>

          <p className="ft-brand__tagline">
            Ethiopia's trusted online marketplace — connecting buyers and
            sellers across the country with ease and confidence.
          </p>

          {/* Contact */}
          <ul className="ft-contact" aria-label="Contact information">
            <li className="ft-contact__item">
              <FaMapMarkerAlt className="ft-contact__icon" aria-hidden="true" />
              <span>Addis Ababa, Nifas Silk Lafto, Wereda 7</span>
            </li>
            <li className="ft-contact__item">
              <FaEnvelope className="ft-contact__icon" aria-hidden="true" />
              <a href="mailto:info@afrogebeya.com" className="ft-contact__link">
                info@afrogebeya.com
              </a>
            </li>
            <li className="ft-contact__item">
              <FaPhoneAlt className="ft-contact__icon" aria-hidden="true" />
              <a href="tel:+251909999988" className="ft-contact__link">
                +251 90 999 9988
              </a>
            </li>
          </ul>

          {/* Social */}
          <div className="ft-social" aria-label="Social media links">
            {SOCIAL_LINKS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                className="ft-social__btn"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
              >
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        {/* ── Shop ── */}
        <FooterCol title="Shop">
          <ul className="ft-col__list">
            {SHOP_LINKS.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="ft-col__link">
                  {l.label}
                  {l.badge && <span className="ft-col__badge">{l.badge}</span>}
                </Link>
              </li>
            ))}
          </ul>
        </FooterCol>

        {/* ── Sell ── */}
        <FooterCol title="Sell on Afrogebeya">
          <ul className="ft-col__list">
            {SELLER_LINKS.map((l) => (
              <li key={l.label}>
                <a
                  href={l.href}
                  className="ft-col__link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </FooterCol>

        {/* ── Support ── */}
        <FooterCol title="Support">
          <ul className="ft-col__list">
            {SUPPORT_LINKS.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="ft-col__link">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </FooterCol>

        {/* ── Legal ── */}
        <FooterCol title="Legal">
          <ul className="ft-col__list">
            {LEGAL_LINKS.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="ft-col__link">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </FooterCol>
      </div>

      {/* ══════════════════════════════════
          Payment methods
      ══════════════════════════════════ */}
      <div className="ft-payments" aria-label="Accepted payment methods">
        <span className="ft-payments__label">We accept</span>
        {PAYMENT_METHODS.map((m) => (
          <span key={m} className="ft-payment-badge">
            {m}
          </span>
        ))}
      </div>

      {/* ══════════════════════════════════
          Bottom bar
      ══════════════════════════════════ */}
      <div className="ft-bottom">
        <div className="ft-bottom__inner">
          <p className="ft-bottom__copy">
            © 2017–{new Date().getFullYear()}{" "}
            <span>Afrogebeya Technologies</span>. All rights reserved.
          </p>
          <nav className="ft-bottom__links" aria-label="Footer legal links">
            {LEGAL_LINKS.map((l, i) => (
              <React.Fragment key={l.label}>
                {i > 0 && (
                  <span className="ft-bottom__sep" aria-hidden="true">
                    ·
                  </span>
                )}
                <Link to={l.to} className="ft-bottom__link">
                  {l.label}
                </Link>
              </React.Fragment>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
}
